import { debounce } from '@debbie/common/dist/util/index.js';
import { atom } from 'jotai';
import { useAtomValue } from 'jotai';
import jotaiStore from '../jotai-store.js';
import { getTenantId } from '../tenant/selected.js';
import { getFilterFromLocalStorage, persistFiltersToLocalStorage, } from './localStorage.js';
const tenantId = localStorage.getItem('selectedTenantId');
const caseFilterAtom = atom((tenantId
    ? getFilterFromLocalStorage(tenantId)
    : { creditorIds: [] }));
// Persist changes to localStorage (replaces store.subscribe in store.ts)
jotaiStore.sub(caseFilterAtom, () => {
    debounce('persistCaseFilter', () => {
        const caseFilter = jotaiStore.get(caseFilterAtom);
        const tenantId = getTenantId();
        if (tenantId) {
            persistFiltersToLocalStorage(tenantId, caseFilter);
        }
    }, 300);
});
export const useCaseFilter = () => useAtomValue(caseFilterAtom);
export const getCaseFilter = () => jotaiStore.get(caseFilterAtom);
export const setSelectedCreditors = (creditors) => {
    const current = jotaiStore.get(caseFilterAtom);
    jotaiStore.set(caseFilterAtom, { ...current, creditorIds: creditors });
};
export const updateFilter = (filter) => {
    const current = jotaiStore.get(caseFilterAtom);
    jotaiStore.set(caseFilterAtom, { ...current, ...filter });
};
export const clearFilter = (filterName, isDate, dateField) => {
    const current = jotaiStore.get(caseFilterAtom);
    if (filterName === 'creditorIds') {
        jotaiStore.set(caseFilterAtom, { ...current, creditorIds: [] });
        return;
    }
    const newState = { ...current };
    const filter = newState[filterName];
    if (isDate) {
        if (dateField == null) {
            return;
        }
        if (filter[dateField] && Object.keys(filter).length > 0) {
            delete filter[dateField];
        }
        if (Object.keys(filter).length === 0) {
            delete newState[filterName];
        }
        jotaiStore.set(caseFilterAtom, newState);
        return;
    }
    delete newState[filterName];
    jotaiStore.set(caseFilterAtom, newState);
};
//# sourceMappingURL=caseFilter.js.map